/** Search param keys injected by the AI agent when applying filters programmatically. */
export const AI_SEARCH_PARAM_KEYS = {
  employees: '_ai_employees',
  location: '_ai_location',
  team: '_ai_team',
} as const

/**
 * Returns true if any AI-driven filter param is present with a non-empty value.
 * Use this to detect when the AI agent has navigated to the page with pre-applied filters.
 */
export function hasAiSearchParams(searchParams: URLSearchParams): boolean {
  return Object.values(AI_SEARCH_PARAM_KEYS).some((key) => {
    const value = searchParams.get(key)
    return value !== null && value.trim().length > 0
  })
}
